export enum Country {
  Poland = 1,
  Abroad = 2
}
